// extracted by mini-css-extract-plugin
export var chevron = "_ji-2";
export var dropdownItems = "_ji-0";
export var item = "_ji-1";